import { defineComponent as _defineComponent } from 'vue'
import CustomerDetailsCardEmpty from "@/components/customer/CustomerDetailsCardEmpty";
  import CustomerDetailsCardWaitlist from "@/components/customer/CustomerDetailsCardWaitlist";
  import { useStore } from "vuex";
  import { onMounted, ref } from "vue";
  import router from "@/router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerWaitListView',
  setup(__props, { expose: __expose }) {
  __expose();

  const waitlist = ref([]);
  const store = useStore();
  const customerId = store.state.user.data._id;
  const showSpinner = ref(true);

  function fetchWaitlist() {
    store
      .dispatch("subscription/getSubscription", { customerId })
      .then((response) => {
        waitlist.value = response.data;
      })
      .finally(() => {
        showSpinner.value = false;
      });
  }
  function onWaitlist(item) {
    router.push({
      name: "CustomerWaitlistDetailsView",
      params: { id: item._id },
    });
  }
  onMounted(() => {
    setTimeout(() => {
      fetchWaitlist();
    }, 600);
  });

const __returned__ = { waitlist, store, customerId, showSpinner, fetchWaitlist, onWaitlist, get CustomerDetailsCardEmpty() { return CustomerDetailsCardEmpty }, get CustomerDetailsCardWaitlist() { return CustomerDetailsCardWaitlist }, get useStore() { return useStore }, onMounted, ref, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})